import { render, staticRenderFns } from "./SRichTextViewer.vue?vue&type=template&id=542c09dd&lang=pug"
import script from "./SRichTextViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRichTextViewer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports